import React from "react";
import PropTypes from "prop-types";
import ContractItem from "./ContractItem.jsx";
const ContractList = ({ contracts, setHasError }) => {
  return (
    <div className="exist-contracts">
      {contracts.map(contract => (
        <ContractItem key={contract.contractId} {...contract} setHasError={setHasError} />
      ))}
    </div>
  );
};

ContractList.propTypes = {
  contracts: PropTypes.array.isRequired,
  setHasError: PropTypes.func.isRequired,
};

export default ContractList;
